import { Atom, state } from ":mods";
import { For } from "solid-js";

export function Accordion(props: {
  title: string;
  tabs: { title: string; element: JSX.Element | JSX.Element[] }[];
  disabled?: boolean;
}) {
  const $active_tab = state.create(props.tabs[0]);
  return (
    <Atom.Foldable.Accordion
      title={props.title}
      disabled={props.disabled}
      class="flex flex-col w-full h-fit"
      groupClass="bg-gray px-2 capitalize"
      // iconClass="icon-tabler:arrow-big-right-filled bg-red w-24 h-24px"
    >
      <div class="sticky top-0 w-full flex flex-row">
        <For each={props.tabs}>
          {(item) => {
            return (
              <button
                class={`
                rounded-lg px-2 py-1  !capitalize w-full disabled:(opacity-50 cursor-not-allowed)
                ${
                  $active_tab.value.title === item.title ? " text#pt bg#p shadow-lg " : " text#p bg#pt cursor-pointer "
                } 
                `}
                // disabled={
                //   (item === "group" && !props.content) || (item === "item" && !props.item) || props.mode === "view"
                // }
                onClick={() => $active_tab.set(item)}
              >
                {item.title}
              </button>
            );
          }}
        </For>
      </div>
      {$active_tab.value.element}
    </Atom.Foldable.Accordion>
  );
}
